enum Environment {

    DEV2 = "dev2",
    QA2 = "qa2",
    ST = "st",
    PROD = "prod",
}


namespace Environment {

    export function isDev(): boolean {
        return process.env.ENVIRONMENT === Environment.DEV2;
    }

    export function isProd(): boolean {
        return process.env.ENVIRONMENT === Environment.PROD;
    }

    export function isStProd(): boolean {
        return process.env.ENVIRONMENT === Environment.ST || process.env.ENVIRONMENT === Environment.PROD;
    }
}

export {Environment};
